
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Kothrudtomumbaicabservice() {



    const cardData =
    {
        keyword: 'Kothrud to Mumbai Cab Service',
        heading: 'Meghana Cab : Kothrud to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Kothrud to Mumbai Cab Service, ensuring a comfortable, safe, and timely journey from one of Pune’s prominent residential areas to Mumbai. Whether it is for business travel, airport transfers, family outings, or a weekend trip, our fleet of well-maintained Hatchbacks, Sedans, SUVs, and Innova Crysta vehicles caters to all your travel needs. Enjoy professional drivers, door-to-door service, transparent fares, and 24/7 customer support. Book your Kothrud to Mumbai Cab with Meghana Cab and experience hassle-free intercity travel with complete peace of mind.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
   
 
   {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Kothrud to Mumbai Taxi Booking",
        "description": "Easily book your taxi from Kothrud to Mumbai with our seamless and user-friendly platform. Enjoy instant confirmations, multiple vehicle options, and a smooth journey backed by punctual pickups and courteous drivers."
    },
    {
        "name": "One Way Cab Kothrud to Mumbai",
        "description": "Our one-way cab service from Kothrud to Mumbai is perfect for travelers needing a single journey with no return. Ideal for airport transfers, city visits, or personal travel, with reliable drivers and clean, comfortable cars."
    },
    {
        "name": "Round Trip Cab Kothrud to Mumbai",
        "description": "Planning to return the same day or after a few days? Book our round-trip cab from Kothrud to Mumbai for flexible timing, affordable round fares, and professional service that ensures your comfort in both directions."
    },
    {
        "name": "Online Booking Kothrud to Mumbai Cab",
        "description": "Book your Kothrud to Mumbai cab online in minutes. Our secure, hassle-free online system lets you select vehicle type, compare prices, and receive instant booking confirmation – all from the comfort of your home."
    },
    {
        "name": "Budget Travel Cab Kothrud to Mumbai",
        "description": "Get the best deals with our budget cab service from Kothrud to Mumbai. We offer low-cost travel without cutting corners on safety, cleanliness, or reliability, making group and solo travel economical and efficient."
    },
    {
        "name": "SUV Cab Hire Kothrud to Mumbai",
        "description": "Hire a spacious SUV from Kothrud to Mumbai for extra comfort and legroom. Ideal for families, small groups, or travelers with luggage, our SUVs provide a stable and enjoyable long-distance ride."
    },
    {
        "name": "Sedan Hire Kothrud to Mumbai",
        "description": "Travel in comfort and style with our sedan cab service from Kothrud to Mumbai. These AC vehicles are ideal for business trips, solo travelers, or couples seeking a smooth and elegant ride."
    },
    {
        "name": "Family Cab Kothrud to Mumbai",
        "description": "Our family cab service from Kothrud to Mumbai ensures that your loved ones travel in comfort and safety. Spacious interiors, friendly drivers, and careful handling make this perfect for family getaways or functions."
    },
    {
        "name": "Chauffeur Service Kothrud to Mumbai",
        "description": "Opt for our chauffeur-driven cabs from Kothrud to Mumbai for a premium, stress-free ride. Our drivers are courteous, professionally trained, and focused on providing a smooth and personalized journey."
    },
    {
        "name": "Long Route Taxi Kothrud to Mumbai",
        "description": "Heading for a long ride? Our long-route taxi service from Kothrud to Mumbai ensures reliable vehicles, comfort over extended hours, and experienced drivers trained in highway travel for a safe, smooth experience."
    },
    {
        "name": "Corporate Cab Kothrud to Mumbai",
        "description": "Manage your business travel efficiently with our corporate cab service from Kothrud to Mumbai. With punctual pickups, invoicing support, and courteous drivers, we serve professionals and teams on tight schedules."
    },
    {
        "name": "Private Cab Kothrud to Mumbai",
        "description": "Enjoy complete privacy and comfort in our private cab service from Kothrud to Mumbai. Ideal for executives, solo travelers, or couples, this option ensures uninterrupted, secure travel to your destination."
    },
    {
        "name": "Fast Travel Kothrud to Mumbai Cab",
        "description": "In a hurry? Choose our fast travel cab from Kothrud to Mumbai for quick booking, real-time tracking, and reliable service that gets you to your destination on time with minimal delays or stops."
    },
    {
        "name": "Affordable Cabs Kothrud to Mumbai",
        "description": "Travel smart with our affordable taxi options from Kothrud to Mumbai. We combine competitive rates with dependable service, offering multiple car types to suit your travel style and budget."
    },
    {
        "name": "24/7 Taxi Kothrud to Mumbai",
        "description": "No matter the time, our 24/7 cab service from Kothrud to Mumbai is available day and night. Ideal for early morning flights, late-night travel, or emergency trips – always ready when you need it."
    }
],
"tableData": [
    ["Kothrud to Mumbai Taxi Booking", "One Way Cab Kothrud to Mumbai"],
    ["Round Trip Cab Kothrud to Mumbai", "Online Booking Kothrud to Mumbai Cab"],
    ["Budget Travel Cab Kothrud to Mumbai", "SUV Cab Hire Kothrud to Mumbai"],
    ["Sedan Hire Kothrud to Mumbai", "Family Cab Kothrud to Mumbai"],
    ["Chauffeur Service Kothrud to Mumbai", "Long Route Taxi Kothrud to Mumbai"],
    ["Corporate Cab Kothrud to Mumbai", "Private Cab Kothrud to Mumbai"],
    ["Fast Travel Kothrud to Mumbai Cab", "Affordable Cabs Kothrud to Mumbai"],
    ["24/7 Taxi Kothrud to Mumbai", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Reliable Kothrud to Mumbai Cab Service",
        "WhyChoosedescription": "Our Kothrud to Mumbai cab service ensures timely pickups, smooth rides, and stress-free intercity travel. Whether you’re heading to Mumbai for work, leisure, or an airport transfer, we provide a dependable and efficient travel experience."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in air-conditioned cabs that are regularly cleaned and well-serviced. Our vehicles offer ample legroom, soft seating, and enough space for luggage—perfect for both short and long-distance travel."
    },
    {
        "WhyChooseheading": "Trained and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are courteous, licensed, and well-versed with the Kothrud to Mumbai route. They follow safety protocols, respect your privacy, and ensure a smooth, punctual journey every time."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "We offer affordable and clearly structured fares that include fuel, tolls, taxes, and driver charges. There are no hidden fees—just honest pricing with great value for every rupee you spend."
    },
    {
        "WhyChooseheading": "Flexible Booking and Travel Plans",
        "WhyChoosedescription": "Choose from one-way trips, round trips, or hourly rentals depending on your needs. Customize pickup and drop-off points across Kothrud and Mumbai with full control over your schedule and stops."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop-off Service",
        "WhyChoosedescription": "We offer convenient door-to-door service. Get picked up directly from your home or office in Kothrud and dropped exactly where you need to go in Mumbai, saving you time and hassle."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, Business, and Family Travel",
        "WhyChoosedescription": "Whether you're traveling to Mumbai International Airport, a business meeting, or a family function, our cab service is designed for all purposes, offering comfort and reliability every step of the way."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Customer Care",
        "WhyChoosedescription": "Our customer support team is available round-the-clock to assist with bookings, rescheduling, cancellations, or special travel requests. We’re here to make your journey smooth and hassle-free, anytime you need us."
    }
]


























    }

const faqData = [
    {
        question: "How do I book a cab from Kothrud to Mumbai?",
        answer: "You can book a cab by calling Meghana Cab at +91 9075462128 or through our website for easy and quick booking."
    },
    {
        question: "What is the estimated travel time from Kothrud to Mumbai by cab?",
        answer: "The journey usually takes around 3 to 4 hours, depending on traffic and road conditions."
    },
    {
        question: "Are one way and round trip cab services available from Kothrud to Mumbai?",
        answer: "Yes, Meghana Cab offers both one way and round trip cab options for your convenience."
    },
    {
        question: "What types of vehicles are available for the Kothrud to Mumbai route?",
        answer: "We provide a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers."
    },
    {
        question: "Is the Kothrud to Mumbai cab service available 24/7?",
        answer: "Yes, our cab service operates round the clock to fit your schedule."
    },
    {
        question: "Does the fare include tolls, fuel, and driver charges?",
        answer: "Yes, the fare includes fuel, tolls, and driver fees. Additional waiting or parking charges may apply."
    },
    {
        question: "Can I book a cab from Kothrud to Mumbai on short notice?",
        answer: "Yes, last-minute bookings are accepted based on availability. Please contact us directly for urgent requests."
    },
    {
        question: "Is online booking available for the Kothrud to Mumbai cab service?",
        answer: "Yes, you can book online anytime through our secure website."
    },
    {
        question: "Can I request stops for breaks or meals during the trip?",
        answer: "Yes, stops can be arranged on request. Please inform us when booking or notify the driver."
    },
    {
        question: "Are the drivers experienced with the Kothrud to Mumbai route?",
        answer: "Yes, our drivers are professional and knowledgeable about the best routes for a safe journey."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Amit Jadhav',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The cab service from Kothrud to Mumbai was excellent. The driver was punctual and the ride was very comfortable.”',
    },
    {
        name: 'Ms. Neha Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Hassle-free booking and reliable service. Meghana Cab made my trip from Kothrud to Mumbai smooth and convenient.”',
    },
];























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kothrud to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/kothrud-to-mumbai-cab.jpg",
  "description": "Book reliable and affordable cabs from Kothrud to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven cars. Available for one-way and round trips with 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/kothrud-to-mumbai-cab-service"
  }
};








    return (
        <div>


<Helmet>
  <title>Kothrud to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Affordable and reliable cab service from Kothrud to Mumbai by Meghana Cabs. Book AC Sedans, SUVs, or chauffeur-driven cars online. Available 24/7 for one-way and round trip travel." 
  />
  <meta 
    name="keywords" 
    content="Kothrud to Mumbai Taxi Booking, One Way Cab Kothrud to Mumbai, Round Trip Cab Kothrud to Mumbai, Online Booking Kothrud to Mumbai Cab, Budget Travel Cab Kothrud to Mumbai, SUV Cab Hire Kothrud to Mumbai, Sedan Hire Kothrud to Mumbai, Family Cab Kothrud to Mumbai, Chauffeur Service Kothrud to Mumbai, Long Route Taxi Kothrud to Mumbai, Corporate Cab Kothrud to Mumbai, Private Cab Kothrud to Mumbai, Fast Travel Kothrud to Mumbai Cab, Affordable Cabs Kothrud to Mumbai, 24/7 Taxi Kothrud to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/68.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kothrudtomumbaicabservice;